export default "__VITE_PUBLIC_ASSET__3f1d1be1__"